import request from '@/utils/request'

export function getXhHyhkList(data) {
  return request({
    url: '/api/Extend/LqXhHyhk',
    method: 'get',
    data
  })
}

export function getXhHyhkInfo(id) {
  return request({
    url: `/api/Extend/LqXhHyhk/${id}`,
    method: 'get'
  })
}

export function createXhHyhk(data) {
  return request({
    url: '/api/Extend/LqXhHyhk',
    method: 'post',
    data
  })
}
